export enum ResourceType {
  DOCUMENT = -1,
  LINK = -2,
}
